/* eslint-disable no-console */
import { find } from "lodash";
import { format, isValid } from "date-fns";
import { parse, differenceInYears } from "date-fns";
import { DATE_FORMAT, SEARCH_TIME_FORMAT, UAE } from "../constants";

export const getDisplayTextUsingDatalistValue = (objectArr, value) => {
  const objectFound = find(objectArr, { value });
  return objectFound ? objectFound.displayText : "";
};

export const getObjectUsingDatalistValue = (objectArr, value) => {
  const objectFound = find(objectArr, { value });
  return objectFound ? objectFound : "";
};
export const getSignatoryId = freeField4 => {
  let signatoryId = "";
  let signatoryIds = [];
  if (freeField4 === "") {
    signatoryId = "SID1";
  } else {
    signatoryIds = JSON.parse(freeField4);
    signatoryId = "SID" + (signatoryIds.length + 1);
  }
  signatoryIds.push(signatoryId);
  return { signatoryId, signatoryIds };
};

export const getDefaultErrorText = financeType => {
  let text = `We regret that we are unable to  offer you RAKBANK ${financeType} Finance 
  as the details provided do not meet the Bank's policy.
  \n Thank you for your interest in RAKBANK ${financeType} Finance`;
  return text;
};

export const getMinExpiryDate = () => {
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

export const validateAndFormatDate = value => {
  if (isValid(value)) {
    return format(value, DATE_FORMAT);
  }
  return value;
};

export const getTodayFormattedTime = () => {
  let time = format(new Date().getTime(), SEARCH_TIME_FORMAT);
  return `T${time}.999Z`;
};

/**
 * Format a large number into a human-readable string with units.
 *
 * @param {number} num - The number to format
 * @returns {string} The formatted string (e.g., 1.2 Mn, 3.4 Bn, 5 K)
 */
export const formatLargeNumber = num => {
  if (num >= 1e12) return (num / 1e12).toFixed(2).replace(/\.00$/, "") + " Tn";
  if (num >= 1e9) return (num / 1e9).toFixed(2).replace(/\.00$/, "") + " Bn";
  if (num >= 1e6) return (num / 1e6).toFixed(2).replace(/\.00$/, "") + " Mn";
  if (num >= 1e3) return (num / 1e3).toFixed(2).replace(/\.00$/, "") + " K";
  return num.toString();
};

export const isAnEligibleStakeholder = stakeholder => {
  let eligible = true;
  if (stakeholder.isShareholderACompany !== true) {
    const dateOfBirth = parse(stakeholder.dateOfBirth, "yyyy-MM-dd", new Date());
    const age = differenceInYears(new Date(), dateOfBirth);
    eligible = age >= 21 && stakeholder.residenceCountry === UAE;
  }
  return eligible;
};

export const isDirectConsentAllowed = (signatories, applicantInfo) => {
  let directConsent = false;
  if (signatories.length === 1) {
    const { contactDetails = {} } = signatories[0];
    const {
      preferredEmail = "",
      preferredMobileCountryCode = "",
      preferredMobileNo = ""
    } = contactDetails;
    const { email = "", countryCode = "", mobileNo = "" } = applicantInfo;
    if (
      preferredEmail === email &&
      preferredMobileCountryCode === countryCode &&
      preferredMobileNo === mobileNo
    ) {
      directConsent = true;
    }
  }
  return directConsent;
};

export const getIndustriesSubcategory = (allSubCategories, subCategory) => {
  return allSubCategories.filter(({ value }) => value === subCategory);
};

export const removeUnselectedSubCategories = (allSubCategories, previousSelectedSubCategories) => {
  return allSubCategories.filter(sub => !previousSelectedSubCategories.includes(sub.value));
};

export const getCountriesOtherthanUAE = countries => {
  return countries.filter(country => country.code !== UAE);
};
